module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hintbox"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.full),
      expression: "!full"
    }],
    staticClass: "hintbox-holder",
    on: {
      "click": function($event) {
        _vm.full = true
      }
    }
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.full),
      expression: "full"
    }],
    staticClass: "hintbox-full"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("常见问题")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("QQ群：461571276")]), _vm._v(" "), _c('a', {
    staticClass: "block-btn",
    on: {
      "click": function($event) {
        _vm.full = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-cancel"
  })])]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://ppj.kf5.com/hc/kb/article/1062142/",
      "target": "_blank"
    }
  }, [_vm._v("如何使用微信录制语音微课")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/createQuiz",
      "target": "_blank"
    }
  }, [_vm._v("如何在PPT中插入答题，制作小测验？")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/createForm",
      "target": "_blank"
    }
  }, [_vm._v("如何插入表单，实现数据搜集")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/size",
      "target": "_blank"
    }
  }, [_vm._v("如何制作竖版PPT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbdb5520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/hintbox.vue
// module id = 950
// module chunks = 3